
import { itemIconNode } from "./itemicon";

const PATHS: Record<number, string> = {
  1: "M4 20 L17 7 L20 10 L7 23 Z M3 15 L9 21",
  2: "M12 2 L21 6 Q21 18 12 22 Q3 18 3 6 Z",
  3: "M9 2 H15 V7 A7 7 0 1 1 9 7 Z",
  4: "M3 7 H21 V19 H3 Z M3 13 H21",
};

export const ITEM_KIND_OTHER = 4;

const FALLBACK_PATH = PATHS[ITEM_KIND_OTHER];

/** The path for an item class, falling back rather than drawing nothing: a
 *  server that adds a class must not make items invisible on an old client. */
export function pathFor(kind: number): string {
  return PATHS[kind] ?? FALLBACK_PATH;
}

export function iconFor(kind: number, doc: Document = document): SVGSVGElement {
  const svg = doc.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("class", "bag-glyph");
  svg.setAttribute("aria-hidden", "true");

  const path = doc.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", pathFor(kind));
  svg.append(path);
  return svg;
}

export function itemArtNode(
  vnum: number,
  kind: number,
  doc: Document = document,
  extraClass?: string,
): Element {
  const painted = itemIconNode(vnum, doc);
  if (painted !== null) return painted;
  const glyph = iconFor(kind, doc);
  if (extraClass !== undefined) glyph.classList.add(extraClass);
  return glyph;
}
